exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".frontend .ti-item,.frontend .ti-tag{color:#000!important}.frontend .ti-item.ti-selected-item,.frontend .ti-tag.ti-selected-item{border:1px solid #000}.frontend .ti-item{border:1px solid transparent}", ""]);

// exports
